<template>
    <div class="ag-radio-group">
        <v-radio-group
            v-model="model"
            :name="`${params.node.data?.productKey}-radio-group`"
            :disabled="isDisabled"
            @change="onChange"
        >
            <v-radio :value="true" class="ag-radio" :ripple="false" @click="onClick" />
        </v-radio-group>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    data() {
        return {
            isSelected: false,
        };
    },
    computed: {
        model: {
            get() {
                // Getting the value from the params ensures this component is responsive when
                // the radio button value is changed outside of this component (e.g. by a Vuex value changing).
                return this.params.value;
            },
            set(newValue) {
                // Set the internal state of this component as the value changes from clicking the radio button.
                this.isSelected = newValue;
            },
        },

        isDisabled() {
            return this.isReadOnly || this.params.context?.isReadOnly();
        },
    },
    created() {
        // Ensure the internal state is set correctly when the component is first created.
        this.isSelected = this.params.value;
    },
    methods: {
        onChange() {
            const entityIdFieldName = this.params.entityIdFieldName;

            if (!entityIdFieldName) {
                return;
            }

            this.params.onRadioButtonChange({
                entityId: this.params.data[entityIdFieldName],
                isSelected: this.isSelected,
            });

            // Ensure any data changes made as part of onRadioButtonChange
            // are reflected in the actual cell values.
            this.params.api.refreshCells({ columns: [this.params.column] });
        },

        onClick() {
            if (!this.params.allowRadioButtonDeselect || !this.model) {
                return;
            }

            this.params.onRadioButtonDeselect();
            this.isSelected = false;

            // Ensure any data changes made as part of onRadioButtonDeselect
            // are reflected in the actual cell values.
            this.params.api.refreshCells({ columns: [this.params.column] });
        },
    },
});
</script>

<style lang="scss">
.ag-radio {
    margin: 0;
}

.ag-radio-group {
    margin: 0;
}

.ag-radio-group {
    .v-radio {
        margin-top: 1rem;
        .v-selection-control {
            &__wrapper {
                .mdi-radiobox-marked {
                    color: #2f477c !important;
                }
                .v-icon {
                    font-size: 2.4rem;
                }
            }
        }
    }
}
</style>
